import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, onMounted, reactive, ref, shallowRef } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRoute, useRouter } from "vue-router";
import { ArrowRight } from "@element-plus/icons";
import AMapLoader from "@amap/amap-jsapi-loader";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  //name: "Information",
  components: {
    Head: Head,
    ArrowRight: ArrowRight
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var fieldId = route.query.fieldId;
    var mys = route.query.my;
    var baseUrl = process.env.VUE_APP_BASE_URL;
    var keyword = ref(""); // 存储搜索用的数据

    var Data = reactive({
      detail: {
        longitude: '',
        latitude: ''
      },
      searchContent: "",
      search: {
        startTime: "",
        endTime: "",
        pageIndex: 1,
        pageSize: 10,
        fieldName: ""
      },
      hrefs: ''
    });

    function getDetail() {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti2, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["FieldDetail"](fieldId);

              case 2:
                _yield$globalProperti2 = _context3.sent;
                data = _yield$globalProperti2.data;
                Data.detail = data;
                Data.hrefs = "http://api.map.baidu.com/geocoder?address=".concat(data.address, "&output=html&src=webapp.baidu.openAPIdemo");

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getDetail.apply(this, arguments);
    }

    var map = shallowRef();

    var ininMap = function ininMap() {
      AMapLoader.load({
        key: "3e478a83e20ad7cff5d02006de469a4d",
        version: "1.4.4",
        plugins: ["AMap.PlaceSearch", "AMap.AutoComplete"]
      }).then(function (AMap) {
        map.value = new AMap.Map('container', {
          resizeEnable: true,
          zoom: 9.5,
          center: [Data.detail.longitude, Data.detail.latitude]
        });
        var marker = new AMap.Marker({
          position: [Data.detail.longitude, Data.detail.latitude],
          map: map.value
        });
        map.value.add(marker);
      });
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDetail();

            case 2:
              _context.next = 4;
              return showMap.handleMap();

            case 4:
              _context.next = 6;
              return ininMap();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    function backfun() {
      router.back();
    }

    var handleClick = function handleClick(id, delFlag) {
      if (delFlag == 0) {
        router.push({
          name: "FieldAppointment",
          query: {
            field: id
          }
        });
      } else if (delFlag == 1) {
        ElMessage.warning("该场地已暂停使用");
      } else {
        ElMessage.warning("该场地正在维修中");
      }
    }; //跳转


    var jump = function jump() {
      window.location.href = Data.hrefs;
    }; //地图开关


    var showMap = reactive({
      show: true,
      handleMap: function handleMap() {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _yield$globalProperti, data;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["watchMap"]();

                case 2:
                  _yield$globalProperti = _context2.sent;
                  data = _yield$globalProperti.data;
                  showMap.show = data.configValue == 'on' ? true : false;

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    });
    return {
      getDetail: getDetail,
      Data: Data,
      backfun: backfun,
      baseUrl: baseUrl,
      handleClick: handleClick,
      keyword: keyword,
      map: map,
      ininMap: ininMap,
      jump: jump,
      mys: mys,
      showMap: showMap
    };
  }
});